import React from "react"
import styled from "styled-components"
import { colors } from "../../lib/colors"
import Path from "./styled"
export default function CustomReply({ betReplyResponse }: any) {
  const { rolled, winCoef } = betReplyResponse
  return (
    <div>
      <Path rolled={rolled} />
      <br></br>
      <br></br>
      <h3
        style={{
          marginBottom: 6,
          fontWeight: 700,
          fontStyle: "normal",
          lineHeight: "16px",
          fontSize: "16px",
          color: "#C7C7C7",
        }}
      >
        COEFICIENT
      </h3>
      <Coef>{winCoef}</Coef>
    </div>
  )
}

const Coef = styled.div`
  width: 40px;
  height: 40px;
  background-color: #ffb000;
  color: ${colors.primary};
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 31px;
`
